import { Component } from "preact";
import MerchantInfo from "./merchantinfo";
import PaymentFields from "./paymentfields";
import NumberInput from "./inputs/number";
import TextInput from "./inputs/text";
import ListInput from "./inputs/list";
import DateInput from "./inputs/date";
import DropdownAmountInput from "./inputs/dropdown-amount";
import _constant from "../../utils/constants";
import common from "../../utils/common";
import FooterLink from "./footerlink";
import { intializeLogger, logEvent } from "../../utils/logger";
import AmountInput from "./inputs/user-amount";
import MobileNumberInput from "./inputs/mobilenumber";
import MerchantAmountInput from "./inputs/merchant-amount";
import QuantityAmount from "./inputs/quantity-amount";
import PartialAmountInput from "./inputs/partial-amount";
import { set } from "../../utils/cache";
import { getKey, numberWithoutCommas } from "../../utils/utility";
import CheckoutJS from "./checkoutjs";
import data from '../../../mock-app-data/form/date-widget/index'
import { dropDownAmountField } from "../../../mock-app-data/form/amount-fields/index";
export default class PaymentForm extends Component {
  constructor(props) {
    super(props);
    window.APP_DATA = window.APP_DATA ? window.APP_DATA : {};
    //window.APP_DATA = dropDownAmountField;
    this.PaymentFormData = common.parsePaymentFormData(window.APP_DATA);
    this.PaymentFormData.fields = this.PaymentFormData.fields ? this.PaymentFormData.fields : [];
    this.partialAmountData = this.PaymentFormData.partialAmountData ? this.PaymentFormData.partialAmountData : {};
    set(_constant.merchantName, this.PaymentFormData.merchantName ? this.PaymentFormData.merchantName : "");
    intializeLogger("paymentForm", {
      page: "paymentForm Page",
      linkId: this.PaymentFormData.linkId ? this.PaymentFormData.linkId : "",
      mid: this.PaymentFormData.merchantId ? this.PaymentFormData.merchantId : ""
    });
    logEvent({ eventType: "ON_PAGE_LOAD", eventValue: "App Data", appData: common.parseFormAppData(window.APP_DATA) });
    this.state = {
      buttonAmount: 0,
      isCheckoutjsEnabled: false,
      directCheckoutjsInvoke: false,
      checkoutjsLoader: false
    };
    this.setInitialTotalAmount();

    const mid = getKey(this.PaymentFormData, "merchantId", undefined);
    const host = common.getAPIHOST();
    this.checkoutScript = common.setupCheckoutJS(host, mid);
  }

  fieldTypeMap = {
    [_constant.CUSTOM_TEXT]: TextInput,
    [_constant.CUSTOM_NUMBER]: NumberInput,
    [_constant.CUSTOM_DROPDOWN]: ListInput,
    [_constant.CUSTOM_DATE]: DateInput,
    [_constant.CUSTOM_AMOUNT]: AmountInput,
    [_constant.CUSTOM_MOBILE_NUMBER]: MobileNumberInput,
    [_constant.CUSTOM_AMOUNT_MERCHANT]: MerchantAmountInput,
    [_constant.CUSTOM_AMOUNT_QUANTATIVE]: QuantityAmount,
    [_constant.CUSTOM_AMOUNT_PARTIAL]: PartialAmountInput,
    [_constant.CUSTOM_AMOUNT_DROPDOWN]: DropdownAmountInput
  };

  getFormFields = (
    inputValue,
    isError,
    errorName,
    type,
    name,
    constraints,
    placeholder,
    subText,
    index,
    size = 100,
    updateFormValue,
    clearErrorData,
    updateAmount
  ) => {
    const InputField = this.fieldTypeMap[type];
    return InputField ? (
      <div className="custom-length" style={`width:${size}%`}>
        <div className="spacer">
          <InputField
            inputValue={inputValue}
            isError={isError}
            errorName={errorName}
            placeholder={placeholder}
            name={name}
            constraints={constraints}
            subText={subText}
            index={index}
            updateFormValue={updateFormValue}
            clearErrorData={clearErrorData}
            updateAmount={updateAmount}
            partialAmountData={this.partialAmountData}
          />
        </div>
      </div>
    ) : (
      ""
    );
  };

  setInitialTotalAmount = () => {
    let amt = 0;
    if (this.partialAmountData && this.partialAmountData.isPartialPayment) {
      amt = Number(numberWithoutCommas(this.partialAmountData.payableAmount));
    } else {
      amt = this.PaymentFormData.amount ? Number(numberWithoutCommas(this.PaymentFormData.amount)) : 0;
    }
    this.updateAmount(amt);
  };

  updateAmount = amt => {
    if (!isNaN(amt)) {
      if (this.partialAmountData && this.partialAmountData.isPartialPayment) {
        this.setState({ buttonAmount: amt, showPayLimitExceedError: false, payLimitExceedError: "" });
      } else if ( 
        !isNaN(parseFloat(this.PaymentFormData.maxTxnAmount)) && 
        ((this.state.buttonAmount + amt) > this.PaymentFormData.maxTxnAmount)) { 
          this.setState(prevState => ({ 
          buttonAmount: prevState.buttonAmount + amt,
          showPayLimitExceedError: true,
          payLimitExceedError: `Total payment amount allowed limit exceeded. Please enter an amount less than or equal to ₹${this.PaymentFormData.maxTxnAmount}`
        }))
      } else {
        this.setState(prevState => ({ buttonAmount: prevState.buttonAmount + amt, showPayLimitExceedError: false, payLimitExceedError:"" }));
      }
    }
  };

  showCheckoutJS = () => {
    this.setState({ isCheckoutjsEnabled: true });
  };

  showLoader = () => {
    document.getElementById("ptm-loader").style.display = "block";
  };

  render({}, { buttonAmount, isCheckoutjsEnabled, checkoutjsLoader, showPayLimitExceedError, payLimitExceedError }) {
    return (
      <div>
        {!isCheckoutjsEnabled ? (
          <div className="wrapper">
            <MerchantInfo
              logoURL={this.PaymentFormData.imageName}
              name={this.PaymentFormData.merchantName}
              linkDescription={this.PaymentFormData.linkDescription}
              buttonAmount={buttonAmount}
              partialAmountData={this.partialAmountData}
            />
            <PaymentFields
              getFormFields={this.getFormFields}
              templateInfo={this.PaymentFormData.templateInfo}
              linkId={this.PaymentFormData.linkId}
              fields={this.PaymentFormData.fields}
              amount={this.PaymentFormData.amount}
              showPayLimitExceedError={showPayLimitExceedError}
              payLimitExceedError={payLimitExceedError}
              buttonAmount={buttonAmount}
              updateAmount={this.updateAmount}
              partialAmountData={this.partialAmountData}
              triggerJSCheckout={this.PaymentFormData.triggerJSCheckout}
              showCheckoutJS={this.showCheckoutJS}
              toggleCheckoutjsLoader={() => this.setState({ checkoutjsLoader: true })}
            />
            <div className="footer">
              <FooterLink linkType={this.PaymentFormData.linkType} />
            </div>
          </div>
        ) : null}
        {isCheckoutjsEnabled && checkoutjsLoader && (
          <CheckoutJS show>
            <FooterLink triggerJSCheckout={isCheckoutjsEnabled} linkType={this.PaymentFormData.linkType} />
          </CheckoutJS>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/app.js